module.exports = __webpack_public_path__ + "img/58bf66f.png";